export default {
  gate_url: process.env.VUE_APP_GATE_URL
    ? process.env.VUE_APP_GATE_URL
    : "https://gate.vikingo.org/api/v1/",
  desktop_mode: false
};



// WEBPACK FOOTER //
// ./src/config.js